import React from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from "components/CustomButtons/Button.js";
import Chaplain from "assets/img/chaplain.jpg";
import CustomInput from "components/CustomInput/CustomInput.js";
import "./index.scss";

export default function Apply() {
    const bg = {
        backgroundColor: `#319795`
      }
  return (
    <div className="apply">
      <Container>
        <Row>
          <Col lg={7} md={12} className="apply-img">
            <img src={Chaplain} alt="" />
          </Col>
          <Col lg={5} md={12} className="right-aside">
            <h2 className="text-bold"> Apply. </h2>
            <p className="text-bold">
              Enter your application form confirmation number
            </p>
            <p>
              Kindly enter your Application Form Confirmation Number in the
              space provided below, and click the submit button to fill your
              Application Form.
            </p>
            <form>
              <CustomInput
                labelText="Application Form Invoice Number"
                id="app-number"
                formControlProps={{
                  fullWidth: true
                }}
              />
              <Button color="success" variant="contained" style={bg}>
                Submit
              </Button>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
